import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Sparkle, ArrowsClockwise } from "@phosphor-icons/react";

export default function AICoachCard() {
  const [text, setText] = useState("");
  const [exists, setExists] = useState(false);
  const [createdAt, setCreatedAt] = useState(null);
  const [generating, setGenerating] = useState(false);
  const esRef = useRef(null);

  useEffect(() => {
    api.get("/ai/coach").then((r) => {
      if (r.data.exists) {
        setText(r.data.text);
        setExists(true);
        setCreatedAt(r.data.created_at);
      }
    }).catch(() => {});
    return () => esRef.current?.close();
  }, []);

  const generate = () => {
    setGenerating(true);
    setText("");
    const es = new EventSource(`${process.env.REACT_APP_BACKEND_URL}/api/ai/coach/stream`, { withCredentials: true });
    esRef.current = es;
    es.onmessage = (e) => {
      try {
        const d = JSON.parse(e.data);
        if (d.t) setText((prev) => prev + d.t);
        if (d.error) {
          toast.error(`Ошибка AI: ${d.error}`);
        }
        if (d.done) {
          es.close();
          setGenerating(false);
          setExists(true);
          setCreatedAt(new Date().toISOString());
        }
      } catch {}
    };
    es.onerror = () => {
      es.close();
      setGenerating(false);
      if (!text) toast.error("Не удалось получить разбор. Попробуйте ещё раз");
    };
  };

  return (
    <div className="glass-card border-primary/30 bg-gradient-to-br from-primary/10 to-transparent p-6" data-testid="ai-coach-card">
      <div className="flex items-center gap-2 mb-1 flex-wrap">
        <Sparkle size={20} weight="fill" className="text-primary" />
        <h3 className="font-heading font-semibold text-lg">AI-тренер · разбор дня</h3>
        {createdAt && !generating && (
          <span className="text-xs text-muted-foreground num">
            от {new Date(createdAt).toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" })}
          </span>
        )}
        <div className="ml-auto">
          <Button size="sm" onClick={generate} disabled={generating} data-testid="ai-coach-generate-button" className="active:scale-95 transition-transform">
            {generating
              ? <><ArrowsClockwise size={14} className="mr-1.5 animate-spin" /> Анализирую…</>
              : exists
              ? <><ArrowsClockwise size={14} className="mr-1.5" /> Обновить разбор</>
              : <><Sparkle size={14} weight="fill" className="mr-1.5" /> Сгенерировать разбор дня</>}
          </Button>
        </div>
      </div>
      {!text && !generating && (
        <p className="text-sm text-muted-foreground mt-2" data-testid="ai-coach-empty">
          Персональный анализ ваших данных Whoop, привычек и задач: вердикт дня, план тренировки, рекомендации по сну.
        </p>
      )}
      {(text || generating) && (
        <div className="mt-3 text-sm leading-relaxed whitespace-pre-wrap" data-testid="ai-coach-text">
          {text}
          {generating && <span className="inline-block w-2 h-4 bg-primary/70 ml-0.5 animate-pulse align-text-bottom" />}
        </div>
      )}
    </div>
  );
}
